<template>
    <div class="visor-pdf-ocr" v-loading="loading || loadingFirma">
        <section class="file-preview">

            <template v-if="pages && pages.length && pages.every(p => p.data) || contentfile">
            
                <!-- TABS -->
                <div :class="['main-tabs', {'full-height': contentfile}]">
                    <el-tabs v-model="activeTab" v-if="pages.length">
                        <el-tab-pane 
                            v-for="(page,i) in pages" 
                            :key="i" 
                            :label="`Página ${page.page == 'U' ? 'última' : page.page}`" 
                            :name="`page_${page.page}`">
                            
                            <div :class="['img-holder-scroll']">
                                <div
                                class="img-holder"
                                ref="img-holder" 
                                :style="{'width': `${100}%`}">
                                
                                    <img 
                                        :ref="`img_${page.page}`"
                                        :src="page.data"
                                        alt="ocr"
                                        @click="clickCoordinatesPage($event, page)"/>

                                    <div 
										:ref="`square_ocr_${page.page}`"
										class="square-hocr"
										><img v-if="firmas.file" :src="`data:image/jpeg;base64,${firmas.file}`" style="width: 100%"/></div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                
                <!-- Firmas -->
                <div class="firma" v-if="firmas">
                    <el-select v-model="firmaSelected" placeholder="Select">
                        <el-option
                        v-for="(size, i) in firmas.sizes"
                        :key="i"
                        :label="size.label"
                        :value="i">
                        </el-option>
                    </el-select>

                    <div class="firma-actions">
                        <el-button @click="$emit('cancel')">Cancelar</el-button>
                        <el-button type="primary" @click="firmar()">Firmar</el-button>
                    </div>
                </div>

                <!-- ZOOM -->
                <!--<div class="zoom" v-if="pages.length">
                    <el-slider
                        v-model="scale"
                        :step="10"
                        :min="0"
                        :max="200"
                        :marks="marks"
                        :show-tooltip="false">
                    </el-slider>
                </div>-->
            </template>
        </section>

        <template v-if="pdf && pdf.numPages">
            <canvas
                style="display: none"
                v-for="page in pdf.numPages"
                :id="`canvas_${page}`"
                :key="page">
            </canvas>
        </template>
    </div>
</template>

<script>
    import {
		getDocumentoPDF,
        postActionData,
        getFirmarImagenes
    } from '@/helpers/api'

    
	export default {
        name: 'PorletVisorPDFFirmarImage',
        props: ['data','id','loadingFirma'],
        data() {
            return {
                error: null,
                loading: false,

                activeTab: 'page_1',
				scale: 100,
				marks: {
					100: {
						style: {
							color: '#1989FA'
						},
						label: this.$createElement('strong', '100%')
					}
				},

                // Gestion archivo
				pdf: null,
				file: null,
                name: '',
				pages: [],
				pdfjsLib: null,
				contentfile: null,
                eventClickImg: {
					px: 0,
					py: 0,
                    page: {
                        page: 1
                    }
				},

                // Firmas disponibles
                firmaSelected: 'medium',
                firmas: null
            }
        },
        watch: {
            firmaSelected() {
                this.renderFirmaImage()
            },
            eventClickImg: {
                handler() {
                    this.renderFirmaImage()
                },
                deep:true
            }
        },
        mounted() {

            this.init()

            this.$emit('created')

        },
        methods: {
            init() {
                this.getData()
            },
            async getData() {

                this.loading = true

                try {

                    let {data} = await getFirmarImagenes({id: this.id})

                    this.firmas = data

                    this.pages = await this.handlePDF(this.data)

                } catch (e) {
                    console.log('Error getData :: ',e)
                }

                this.loading = false

            },
            async handlePDF(pdfData) {
                
                let pdfjsLib = window['pdfjs-dist/build/pdf'];

                // The workerSrc property shall be specified.
                pdfjsLib.GlobalWorkerOptions.workerSrc = '//mozilla.github.io/pdf.js/build/pdf.worker.js';

				let pages = []

				this.loading = true

				try {

					const loadingTask = pdfjsLib.getDocument({data: atob(pdfData)});

					this.pdf = await loadingTask.promise

					const scale = 4

					for(let i = 1; i <= this.pdf.numPages; i++) {

						let page = await this.pdf.getPage(i)
						const viewport = page.getViewport({scale})
			
						let canvas = document.getElementById(`canvas_${i}`)
						let canvasContext = canvas.getContext('2d')
						canvas.height = viewport.height
						canvas.width = viewport.width
						
						let renderTask = page.render({canvasContext, viewport})
						await renderTask.promise

						pages.push({
							page: i,
							data: canvas.toDataURL('image/jpeg'),
							cuadros: []
						})
					}

				} catch (err) {
					console.log(err)
					this.$notify.error({
						title: 'Error',
						message: 'Error al procesar el PDF'
					})
				}
		
				this.loading = false

				return pages
			},
            clickCoordinatesPage (e, page) {

				let elemento = this.$refs[`img_${page.page}`][0]
				
				let bounds = elemento.getBoundingClientRect()
				var left = bounds.left
				var top = bounds.top
				var x = e.pageX - left
				var y = e.pageY - top
				var cw = elemento.clientWidth
				var ch = elemento.clientHeight
				var iw = elemento.naturalWidth
				var ih = elemento.naturalHeight
				var px = x / cw*iw
				var py = y / ch*ih
            
                this.eventClickImg.px = px
                this.eventClickImg.py = py
                this.eventClickImg.page = page
                
			},
            renderFirmaImage() {
                
                let img = this.$refs.[`img_${this.eventClickImg.page.page}`][0]

                let diff = parseFloat(((img.width / img.naturalWidth ) - 1) * (-100)).toFixed(2)

                let firmaSeleccionada = this.firmas.sizes[this.firmaSelected]
                
                let imgOriginal = img.naturalWidth / 4
                let factor = img.width / imgOriginal

                let square = this.$refs[`square_ocr_${this.activeTab.split('_')[1]}`][0].style

                square.width = `${(firmaSeleccionada.width * factor).toFixed(2)}px`
				square.height = `${(firmaSeleccionada.height * factor).toFixed(2)}px`

				square.top = `${this.eventClickImg.py - (this.eventClickImg.py / 100 * diff).toFixed(2)}px`
                square.left = `${this.eventClickImg.px - (this.eventClickImg.px / 100 * diff).toFixed(2)}px`

				/*
                square.width = `${(firmaSeleccionada.width) - ((firmaSeleccionada.width / 100 * diff).toFixed(2)}px`
				square.height = `${firmaSeleccionada.height - (firmaSeleccionada.height / 100 * diff).toFixed(2)}px`
				square.top = `${this.eventClickImg.py - (this.eventClickImg.py / 100 * diff).toFixed(2)}px`
                square.left = `${this.eventClickImg.px -(this.eventClickImg.px / 100 * diff).toFixed(2)}px`
                */
                
            },
            firmar() {
                
                let img = this.$refs.[`img_${this.eventClickImg.page.page}`][0]

                let diff = parseFloat(((img.width / img.naturalWidth ) - 1) * (-100)).toFixed(2)

                let square = this.$refs[`square_ocr_${this.activeTab.split('_')[1]}`][0].style
                
                let imgOriginal = img.naturalWidth / 4
                let factor = img.width / imgOriginal
                
                this.$emit('firmar', {
                    size: this.firmaSelected,
                    page: this.eventClickImg.page.page,
                    top: `${(this.eventClickImg.py - (this.eventClickImg.py / 100 * diff)) / factor}`,
                    left: `${(this.eventClickImg.px - (this.eventClickImg.px / 100 * diff)) / factor}`
                })
            }
        }
	}
</script>

<style lang="scss">
.visor-pdf-ocr {
    display: flex;
    flex-grow: 1;

    header {
        height: 56px;
        box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 16px;
        z-index: 999;
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 15px;
        left: 0;
        right: 0;
        width: auto;
        p {
            font-weight: 600;
            font-size: 1.1rem;
            text-transform: capitalize;
        }
    }

    section.file-preview {
        width: 100%;
        height: -webkit-fill-available;
        position: absolute;
        background-color: white;
        z-index: 9;
        padding: 0px!important;
        flex-flow: column;

        .main-tabs {
            height: 100%;
            &.full-height {
                height: 100%;
            }
            .el-tabs {
                height: 100%;
                display: flex;
                flex-flow: column;
                .el-tabs__content {
                    flex-grow: 1;
                    display: flex;
                    flex-flow: column;
                    .el-tab-pane {
                        flex-grow: 1;
                        display: flex;
                        flex-flow: column;
                        max-height: -webkit-fill-available;
                        .img-holder-scroll {
                            overflow: auto;
                        }
                    }
                }
            }
            .editor {
                overflow: auto;
                height: 100%;
            }
        }

        > .empty {
            text-align: center;
            margin-top: 100px;
            font-weight: 700;
            color: #afafaf;
        }

        .img-holder-scroll {
            overflow: auto;
            .img-holder {
                position: relative;
                overflow: auto;
                width: fit-content;
                transform-origin: 0% 0% 0px;
                .square-hocr {
                    top: 0;
                    position: absolute;
                    border: 1px solid #ff0606;
                    width: 100px;
                    height: 50px;
                }
                img {
                    width: 100%;
                }
            }
            &.cursor {
                cursor: crosshair;
            }
        }

        .zoom {
            .el-slider {
                padding: 10px 15px 20px 15px;
            }
        }

        .firma {
            display: flex;
            justify-content: space-between;
            padding-top: 20px;
        }
    }

    section.file-properties {
        width: 100%;
        border-left: 1px solid #dadada;
        overflow: hidden;
        padding-top: 56px;
        flex-flow: column;
        height: -webkit-fill-available;

        .file-properties-content {
            overflow: auto;
            padding: 15px;
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;

            form {
                width: 400px;
            }
        }

        .button-save {
            background-color: white;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 15px 20px;
            box-shadow: rgba(0, 0, 0, 0.12) 0px 0px 16px;
            > button {
                width: 100%;
            }
        }
    }

    @media(min-width: 768px) {
        section.file-preview,
        section.file-properties {
            position: relative;
            padding-top: 0px;
            display: flex!important;
            flex-flow: column;
        }
    }
}
</style>